<template>
  <div>
    <div class="position">
      <span
        >您现在的位置：<a href="/">首页</a> > 西安12345政务服务便民热线
        >市长信箱</span
      >
      <div>
        <span>

          <span>
          <a>欢迎您 {{this.form.name}}</a>
        </span>
        <span>
          <router-link to="/orderList">
             <a href="javascript:;" class="suqiu-box">我的诉求>></a>
          </router-link>
        </span>

          <a >首页</a>
          <span>/</span>
        </span>
        <span>
          <a>互动</a>
        </span>
      </div>
    </div>
    <div class="container">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="left orderSubmit"
      >
        <div class="top">
          <div class="title" style="display: inline-block">联系信息</div><span v-if="registerWin" style="color:red;">(本界面仅做浏览用途，若您需要提交诉求，请先进行 <a
                @click="getSignUrl" class="aActive">身份认证</a>)</span>
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="姓名"  prop="name">
                  <el-input
                    size="small"
                    v-model="form.name"
                    placeholder="请输入您的姓名"
                    autofocus
                    :disabled="disabledListWin"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="性别" required prop="sex">
                  <el-radio v-model="form.sex" label="1">先生</el-radio>
                  <el-radio v-model="form.sex" label="0">女士</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式"  prop="telephone">
                  <el-input
                    v-model="form.telephone"
                    size="small"
                    :disabled="disabledListWin"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" >
              <el-col :span="7">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="form.email"
                    placeholder="请输入您的邮箱"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13" >
                <el-form-item label="联系地址" prop="contactAddress">
                  <el-input
                    v-model="form.contactAddress"
                    placeholder="请输入您的联系地址"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="是否保密" prop="isSecret">
              <el-radio v-model="form.secret" label="1">保密</el-radio>
              <el-radio v-model="form.secret" label="0">不保密</el-radio>
              <span class="zhu"
                >(注:
                如选择个人信息保密，承办部门将无法与您核实具体信息。)</span
              >
            </el-form-item>
          </div>
        </div>
        <div class="middle">
          <div class="title">诉求内容</div>
          <div>
            <el-row :gutter="20">
              <el-col :span="20">
                <el-form-item
                  label="诉求类型"
                  prop="typeIndex"
                  style="marginbottom: 8px"
                >
                  <el-radio v-model="form.typeIndex"  :label="item.text" v-for="(item,index) in options" :key="index">{{item.text}}</el-radio>
                  <!-- <el-radio v-model="form.typeIndex" label="投诉"
                    >投诉</el-radio
                  >
                  <el-radio v-model="form.typeIndex" label="建议"
                    >建议</el-radio
                  >
                  <el-radio v-model="form.typeIndex" label="求助"
                    >求助</el-radio
                  >
                  <el-radio v-model="form.typeIndex" label="举报"
                    >举报</el-radio
                  > -->
                </el-form-item>
                <el-form-item label="公开意向" prop="overt">
                  <el-radio v-model="form.overt" label="1">是</el-radio>
                  <el-radio v-model="form.overt" label="0">否</el-radio>
                  <span class="zhu"
                    >注:选择公开的将有可能当作案例在网站公开。</span
                  >
                </el-form-item>
                <el-form-item label="事发地点"  prop="address" ref="address">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入详细的事发地点"
                    size="small"
                  ></el-input>
                </el-form-item>
                <el-form-item label="诉求标题"  prop="title" ref="title">
                  <el-input
                    v-model="form.title"
                    placeholder="请输入诉求标题"
                    maxlength="20"
                    show-word-limit
                    size="small"
                  ></el-input>
                </el-form-item>
                <div>
                  <el-form-item label="诉求内容"  prop="content" ref="content">
                    <el-input
                      v-model="form.content"
                      :inline="false"
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 12 }"
                      maxlength="500"
                      show-word-limit
                      placeholder="请填写诉求内容，并描述清楚时间、地点、人物和事情经过"
                      size="small"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="诉求期望" prop="hope" v-if="false">
                    <el-input
                      v-model="form.hope"
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="请输入您的诉求期望，明确说明自己的诉求"
                      maxlength="30"
                      show-word-limit
                      size="small"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="上传附件">
                    <el-upload
                      class="upload-demo"
                      :action="action"
                      :data="formData"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-success="success"
                      :before-remove="beforeRemove"
                      :on-change="handleChange"
                      name="file"
                      multiple
                      :limit="3"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      accept=".doc,.docx,.pdf,.rar,.zip,.7z,.jpg,.png,.gif,.jpeg,.bmp,.avi,.wnv,.3gp,.flv,.mp4,.mp3"
                    >
                      <el-button native-type="button" class="uploadBtn"
                        >选择文件</el-button
                      >
                      <span class="noFile" v-if="fileList == 0"
                        >未选择任何文件</span
                      >
                      <span class="zhu f"
                      >注:上传格式支持:*.doc;*.docx;*.pdf;*.zip;*.7z;*.jpg;*等,大小不超过5M</span
                      >
<!--                      <span class="zhu f"-->
<!--                        >注:上传格式支持:*.jpg;*.gif;*.png;*.doc;*.ppt;*.xls等,大小不超过5M</span-->
<!--                      >-->
                    </el-upload>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="bottom">
          <el-button class="elButton" v-if="!registerWin"  :loading="loading" @click="submitForm('form')">提交</el-button>
          <el-button v-else type="info" disabled>提交</el-button>
          <el-button class="elButton" v-if="!registerWin" ref="reset" @click="resetForm('form')">重置</el-button>
          <el-button v-else type="info" disabled ref="reset" style="margin-left: 20px">重置</el-button>
        </div>
      </el-form>
      <div class="right">
        <hotline />
      </div>
    </div>
  </div>
</template>

<script>
import hotline from "@/components/hotline";
import "@/assets/styles/loc.css";
import conf from "@/config";
export default {
  name: "szxx",
  data() {
    return {
      action: conf.webApi + conf.version + "/portal/file/upload",
      loading: false,
      formData: {
        path: "app",
      },
      evaLoading: false,
      disabledListWin:true,
      form: {
        projectKey: conf.projectKey,
        name: "",
        telephone: "",
        title: "",
        content: "",
        source: "12345热线",
        sourceTwo: "市长信箱",
        dataId: "",
        typeIndex: "",
        secret: "0",
        overt: "0",
        lat: 0,
        lng: 0,
        address: "",
        sex: "1",
        email: "",
        hope: "",
        tokenKey: "1",
        userId: "",
        attachmentUrls: [],
      },
      options:[],
      rules: {
        name: [
          {
            required: true,
            message: "请输入您的姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在1 到 30 个字符",
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "请输入您的联系方式",
            trigger: "blur",
          },
        ],
        // email: [
        //     {
        //         message: "请输入您的邮箱",
        //         trigger: "change",
        //     },
        // ],
        address: [
          {
            required: true,
            message: "请输入详细的事发地点",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入诉求标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请填写诉求内容",
             trigger: 'blur'
          }
        ],
        email: [
             { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] }
        ],
      },
      fileList: [],
      registerWin:true
    };
  },
  components: {
    hotline,
  },
  methods: {
    upButton() {
      return false;
    },
    typeList(){
			 this.getOrderTypeList(res=>{
				 this.options = []
				 for(let j = 0; j < res.length; j++) {
					let item = {
						text:res[j].typeName,
						value:res[j].typeName
					}
					if(item.value.indexOf('骚扰')==-1){
						this.options.push(item)
					}
				 }
				this.form.typeIndex = this.options[0].value;
			 })
			},
    submitForm(form) {
      if(this.form.typeIndex == ''){
        //生成重定向url 并且跳转
        this.$message.error('请选择 诉求类型！');
        return;
      }
      this.form.dataId = this.generateUUID()
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$confirm("确定要提交吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {

              if (this.fileList.length > 0) {
                this.fileList.forEach((i) => {
                  this.form.attachmentUrls.push(i.response.data[0]);
                });
              }else{
                this.form.attachmentUrls = '';
              }
              this.loading = true;
              webAxios
                .post("/portal/channel/dataPutTwo", this.form)
                .then((res) => {
                  if (res.data.code == 200) {
                    this.loading = false;
                    this.$message({
                      type: "success",
                      message: "提交成功",
                    });
                    this.customReset();
                  } else {
                    this.$message({
                    type: "error",
                    message:res.data.message,
                  });
                    this.loading = false;
                  }
                })
                .catch((err) => {
                  console.log(err);
                  this.$message({
                    type: "error",
                    message: "提交失败",
                  });
                  this.loading = false;
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消提交",
              });
            });
        } else {
          return false;
        }
      });
    },
    //重置表单
    resetForm(form) {
      this.customReset();

    },
    //自定义重置表单
    customReset() {
      this.form.email = "";
      this.form.contactAddress = "";
      this.$refs["address"].resetField();
      this.$refs["title"].resetField();
      this.$refs["content"].resetField();
      this.form.hope = "";
      this.form.attachmentUrls = [];
      this.fileList = [];

    },
    handleChange(file, fileList) {
      if (file.size > 5 * Math.pow(1024, 2)) {
        this.$message.error("上传文件大小不能超过5M");
        return;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //文件上传成功
    success(response, file, fileList) {
      this.fileList = fileList;
    },
  },
  created() {
    let code = this.getUrlParams("code");
    // console.log(code);
    if(code == 'szxx'){
      this.sourceTwo = '市长信箱'
    }
    // this.form.name = '李舒达';
    //   this.form.telephone = '15035792103';
    //   this.form.userId = '15035792103';
    this.getUserInfo((res) => {
      if (res.code == 401) {
        this.registerWin=true;
      }else if (res.code == 200) {
        this.registerWin=false;
        this.form.name = res.data.name;
        this.form.telephone = res.data.callPhone;
        this.form.userId = res.data.callPhone;
        this.form.email = res.data.email;
        if(this.form.name==''||this.form.telephone==''){
          this.disabledListWin=false;
        }
      }
    });
    this.typeList();
  },
};
</script>

<style scoped>
@media screen and (max-width: 1200px){
      .container{
        position: static;
        padding: 0px;
    }
}
@media screen and (max-width: 1150px){
    .container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    body .left{
        width: 95%;
        margin-right:0px;
         padding:0px;
        order: 2;
        /* display: flex; */
        justify-content: center;

    }
    body .right{
        width: 95%;
        order: 1;
        margin-bottom: 15px;
    }
    body .boxCenter {
        display: inline;
        margin-left: 0px;
        padding:0px 10px 20px 40px;
        padding: 52px 36px;

    }
    body .f {
      margin-left: 0px;
    }
    .zhu{
        display: block;
    }

}
.aActive{
  cursor:pointer;
  color: #2d85fd;
  font-weight: 400;
  border-bottom: 1px solid #2d85fd;
  padding: 0 10px;
}
.container {
  display: flex;
  justify-content: space-between;
  padding: 0px;
}
.left {
  width: 75%;
  margin-right: 20px;
}
.top,
.middle,
.bottom {
  background: #fff;
  padding: 0 15px 0px 15px;
}
.title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #306bbb;
  line-height: 24px;
  padding: 16px 0;
  border-top: 3px solid #306bbb;
  width: 90px;
  text-align: center;
}
.bottom {
  margin-top: 15px;
  text-align: center;
  padding: 16px;
}
.bottom button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  width: 92px;
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 30px;
  cursor: pointer;
}
.bottom .elButton:nth-child(1) {
  background: linear-gradient(0deg, #306bbb, #2d85fd);
  color: #ffffff;
}
.bottom .elButton:nth-child(2) {
  background: linear-gradient(0deg, #d1d3d6, #f2f2f2);
  color: #666;
  margin-left: 20px;
}
.zhu {
  color: #f82020;
  font-size: 14px;
}
.right {
  width: 25%;
}
.noFile {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  margin-left: 12px;
}
.f {
  margin-left: 44px;
}
.uploadBtn {
  width: 90px;
  height: 29px;
  background: linear-gradient(0deg, #e2e2e2, #ffffff);
  border: 1px solid #dddddd;
  border-radius: 5px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  cursor: pointer;
  padding: 7px;
}
.upload-demo {
  display: inline-block;
}
.suqiu-box{
  color: #2d85fd !important;
  cursor:pointer;
}
</style>
<style>
.orderSubmit .el-form-item {
  margin-bottom: 16px;
}
.orderSubmit .el-form-item__label {
  color: #306bbb !important;
}
.orderSubmit .el-input__inner,
.orderSubmit .el-textarea__inner {
  border: 1px solid #cde2f0;
  border-radius: 5px;
}
.orderSubmit .el-form-item__error {
  padding-top: 0;
}
@media screen and (max-width: 1150px){

    .el-input.is-disabled .el-input__inner,
    .orderSubmit .el-input__inner, .orderSubmit .el-textarea__inner{
        min-width: 220px;
    }
    .el-row{
        /* display: inline-grid; */
            display: block;
    }
    .el-form-item__content{
        margin-left: 0;
    }
    .el-col-7{
        width: 100%;
    }
}
@media screen and (max-width: 1150px){
    .el-row{
        display: inline-grid;

    }
}
</style>
